import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

import RadioSelector from '@cimpress-technology/ff-react-components/lib/RadioSelector';

const radioButtonStyle = css({
  width: '500px'
});

class RadioSelectorField extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    input: PropTypes.object.isRequired,
    buttons: PropTypes.node.isRequired
  };

  render() {
    const { buttons, className, input } = this.props;
    const { value, onChange } = input;

    return (
      <div className={className}>
        <RadioSelector buttonStyle={radioButtonStyle} onClick={onChange} value={value}>
          {buttons.props.children}
        </RadioSelector>
      </div>
    );
  }
}

export default RadioSelectorField;
